(() => {
  if (window.__inventaCartBound) return;
  window.__inventaCartBound = true;

  const root = window.Shopify?.routes?.root || '/';
  const path = name => `${root.replace(/\/$/, '')}/cart/${name}.js`;
  let queue = Promise.resolve();
  let queued = 0;
  let quoteScope = null;
  let checkoutPending = false;
  let focusRevision = 0;
  const pendingLines = new Map();
  const detailEdits = new Map();
  const transitionControls = new Map();
  const enqueue = task => {
    queued++;
    const next = queue.then(task, task).finally(() => { queued--; });
    queue = next.catch(() => {});
    return next;
  };

  function messages() {
    try { return JSON.parse(document.querySelector('[data-inventa-cart-messages]')?.textContent || '{}'); }
    catch { return {}; }
  }

  function surfaceSelector(element) {
    return element.closest('#cart-drawer') ? '#cart-drawer' : '[data-inventa-cart-page]';
  }

  function sectionId(element) {
    const id = element?.closest('[id^="shopify-section-"]')?.id;
    return id?.replace(/^shopify-section-/, '') || null;
  }

  function sectionsToRequest() {
    return [...new Set([sectionId(document.querySelector('[data-inventa-cart-page]')), sectionId(document.querySelector('#cart-drawer'))].filter(Boolean))];
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('cart-count').forEach(element => {
      if ('itemCount' in element) element.itemCount = count;
      else element.textContent = String(count);
    });
    document.querySelectorAll('[data-cart-count]').forEach(element => { element.textContent = String(count); });
  }

  function publishCart(cart) {
    updateHeaderCount(cart.item_count);
    document.dispatchEvent(new CustomEvent('cart:change', {detail: {baseEvent: 'inventa:cart-change', cart, inventaRendered: true}}));
    document.dispatchEvent(new CustomEvent('inventa:cart-updated', {detail: cart}));
  }

  function applyPending() {
    pendingLines.forEach(context => {
      for (const scope of ['#cart-drawer', '[data-inventa-cart-page]']) busy(currentRow({...context, scope}), true);
    });
    if (quoteScope) {
      setQuoteBusy(quoteScope, true);
      document.querySelectorAll('inventa-quantity, [data-inventa-remove], [name="checkout"]').forEach(control => {
        if (!transitionControls.has(control)) transitionControls.set(control, control.hasAttribute('disabled') && control.closest('[data-inventa-line-key]')?.dataset.inventaBusy !== 'true');
        control.setAttribute('disabled', '');
      });
    }
    const form = document.querySelector('#inventa-cart-form');
    detailEdits.forEach((value, name) => {
      const field = form?.elements?.namedItem(name);
      if (field) field.value = value;
    });
    if (checkoutPending) {
      document.querySelectorAll('[name="checkout"]').forEach(button => button.setAttribute('aria-busy', 'true'));
      document.querySelectorAll('[data-inventa-quote-cart]').forEach(button => { button.disabled = true; });
    }
  }

  function replaceSections(sections, expected = sectionsToRequest()) {
    if (!sections) return false;
    const active = document.activeElement;
    const focusedRow = active?.closest?.('[data-inventa-line-key]');
    const replacementFocus = focusedRow ? {context: rowContext(focusedRow), focus: focusContext(focusedRow)} : null;
    const focusedField = !focusedRow && active?.closest?.('#inventa-cart-form') && active.name ? {name: active.name, start: active.selectionStart, end: active.selectionEnd} : null;
    if (focusedField) focusRevision++;
    const parser = new DOMParser();
    let changed = false;
    let complete = expected.every(id => Boolean(sections[id]));
    for (const [id, html] of Object.entries(sections)) {
      if (!html) { complete = false; continue; }
      const parsed = parser.parseFromString(html, 'text/html');
      const target = document.getElementById(`shopify-section-${id}`);
      const source = parsed.getElementById(`shopify-section-${id}`);
      if (!target || !source) { complete = false; continue; }
      const oldDrawer = target.querySelector('#cart-drawer');
      const newDrawer = source.querySelector('#cart-drawer');
      if (oldDrawer && newDrawer) {
        const body = oldDrawer.shadowRoot?.querySelector('[part="body"]');
        const bodyScrollTop = body?.scrollTop;
        const scroll = oldDrawer.querySelector('.inventa-cart-drawer__scroll');
        const scrollTop = scroll?.scrollTop;
        oldDrawer.innerHTML = newDrawer.innerHTML;
        if (body) body.scrollTop = bodyScrollTop;
        const updatedScroll = oldDrawer.querySelector('.inventa-cart-drawer__scroll');
        if (updatedScroll && scrollTop !== undefined) updatedScroll.scrollTop = scrollTop;
      }
      else target.innerHTML = source.innerHTML;
      changed = true;
    }
    applyPending();
    if (replacementFocus) restoreFocus(replacementFocus.context, replacementFocus.focus);
    if (focusedField && document.activeElement === document.body) {
      const field = document.querySelector('#inventa-cart-form')?.elements?.namedItem(focusedField.name);
      field?.focus({preventScroll: true});
      if (typeof focusedField.start === 'number' && field?.setSelectionRange) field.setSelectionRange(focusedField.start, focusedField.end);
    }
    return changed && complete;
  }

  function rowContext(row) {
    return {
      scope: surfaceSelector(row),
      key: row.dataset.inventaLineKey
    };
  }

  function currentRow(context) {
    return document.querySelector(context.scope)?.querySelector(`[data-inventa-line-key="${CSS.escape(context.key)}"]`);
  }

  function focusContext(row) {
    const active = document.activeElement;
    if (!row.contains(active)) return null;
    const rows = Array.from(document.querySelector(surfaceSelector(row))?.querySelectorAll?.('[data-inventa-line-key]') || []);
    const index = rows.indexOf(row);
    return {element: active, revision: ++focusRevision, neighbors: [rows[index + 1]?.dataset.inventaLineKey, rows[index - 1]?.dataset.inventaLineKey].filter(Boolean), selector: active.matches('[data-inventa-remove]') ? '[data-inventa-remove]' : active.matches('[data-inventa-quantity-step]') ? `[data-inventa-quantity-step="${active.dataset.inventaQuantityStep}"]` : '[data-inventa-qty-input]'};
  }

  function restoreFocus(context, focus) {
    if (quoteScope) return;
    if (!focus || focus.revision !== focusRevision || (document.activeElement !== document.body && document.activeElement !== focus.element)) return;
    const row = currentRow(context);
    const preferred = row?.querySelector(focus.selector);
    const control = preferred && !preferred.disabled ? preferred : row?.querySelector('[data-inventa-qty-input]');
    // Removal has no matching row; keep focus within the originating cart surface.
    const neighbor = focus.neighbors.map(key => currentRow({...context, key})).find(Boolean)?.querySelector('[data-inventa-qty-input]');
    const fallback = neighbor || document.querySelector(context.scope)?.querySelector('[data-inventa-qty-input], [data-inventa-quote-cart], a');
    (control || fallback)?.focus({preventScroll: true});
  }

  function busy(row, value) {
    if (!row) return;
    row.dataset.inventaBusy = String(value);
    if (value) row.setAttribute('aria-busy', 'true'); else row.removeAttribute('aria-busy');
    row.querySelector('inventa-quantity')?.toggleAttribute('busy', value);
    const remove = row.querySelector('[data-inventa-remove]');
    if (remove) remove.disabled = value;
    const indicator = row.querySelector('[data-inventa-cart-line-busy]');
    if (indicator) indicator.hidden = !value;
  }

  async function recoverCart(sections) {
    // Shopify can apply an inventory correction even when change.js returns 422.
    // Reload rendered sections and the authoritative cart before displaying the error.
    const sectionUrl = new URL(location.href);
    sectionUrl.searchParams.set('sections', sections.join(','));
    const [cartResponse, sectionResponse] = await Promise.all([
      fetch(`${root}cart.js`, {credentials: 'same-origin', cache: 'no-store'}),
      fetch(sectionUrl, {credentials: 'same-origin', cache: 'no-store'})
    ]);
    if (!cartResponse.ok || !sectionResponse.ok) return false;
    const [cart, html] = await Promise.all([cartResponse.json(), sectionResponse.json()]);
    if (!replaceSections(html, sections)) return false;
    publishCart(cart);
    return true;
  }

  document.addEventListener('inventa:cart-add-items', event => {
    const request = event.detail;
    if (!request || typeof request.resolve !== 'function' || typeof request.reject !== 'function') return;
    request.handled = true;
    const fail = code => Object.assign(new Error(code), {code});
    if (quoteScope || checkoutPending) { request.reject(fail('cart_busy')); return; }
    const items = request.items;
    if (!Array.isArray(items) || !items.length || items.some(item => !Number.isSafeInteger(item.id) || item.id <= 0 || !Number.isSafeInteger(item.quantity) || item.quantity <= 0)) {
      request.reject(fail('invalid_selection')); return;
    }
    enqueue(async () => {
      const readCart = async () => {
        const response = await fetch(`${root}cart.js`, {credentials: 'same-origin', cache: 'no-store'});
        if (!response.ok) throw fail('cart_error');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw fail('cart_error');
        return cart;
      };
      const quantity = (cart, id) => cart.items.filter(line => Number(line.variant_id || line.id) === id).reduce((total, line) => total + line.quantity, 0);
      let cart = await readCart();
      const results = [];
      for (const item of items) {
        const sections = sectionsToRequest();
        const before = quantity(cart, item.id);
        let response, body;
        try {
          response = await fetch(path('add'), {
            method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            body: JSON.stringify({items: [{id: item.id, quantity: item.quantity}], sections, sections_url: location.pathname})
          });
          body = await response.json();
        } catch { /* A lost response is never permission to repeat a mutation. */ }
        try { cart = await readCart(); }
        catch {
          // Reuse the established native-cart fallback after an unconfirmed mutation.
          location.href = `${root}cart`;
          return {results: [...results, {status: 'unknown', added: 0}], cart: null};
        }
        const added = Math.max(0, quantity(cart, item.id) - before);
        const status = added >= item.quantity ? 'added' : added > 0 ? 'partial' : response && !response.ok && response.status < 500 ? 'rejected' : 'unknown';
        if (!replaceSections(body?.sections, sections)) {
          let synchronized = false;
          try { synchronized = await recoverCart(sections); } catch { /* Navigate to authoritative HTML below. */ }
          if (!synchronized) {
            location.href = `${root}cart`;
            return {results: [...results, {status, added}], cart};
          }
        } else publishCart(cart);
        results.push({status, added});
        if (status === 'unknown') break;
      }
      return {results, cart};
    }).then(request.resolve, () => request.reject(fail('cart_error')));
  });

  async function changeQuantity(row, quantity, remove = false) {
    if (row.dataset.inventaBusy === 'true' || pendingLines.has(row.dataset.inventaLineKey) || quoteScope) return;
    const primitive = row.querySelector('inventa-quantity');
    const input = row.querySelector('[data-inventa-qty-input]');
    // Defense at the adapter boundary: empty, invalid and zero edits are never removals.
    if (!remove && (!input || input.value.trim() === '' || !input.validity.valid || !Number.isInteger(quantity) || quantity < 1)) return;
    if (remove && quantity !== 0) return;
    const context = rowContext(row);
    const focus = focusContext(row);
    const oldValue = Number(row.querySelector('[data-inventa-qty-input]')?.defaultValue || 1);
    const fallbackMessage = primitive?.dataset.updateError;
    const retryMessage = primitive?.dataset.retry;
    pendingLines.set(context.key, context);
    busy(row, true);
    applyPending();
    primitive?.clearError();
    try {
      await enqueue(async () => {
        const sections = sectionsToRequest();
        const response = await fetch(path('change'), {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({id: row.dataset.inventaLineKey, quantity, sections, sections_url: location.pathname})
        });
        const cart = await response.json();
        if (!response.ok || cart.status) {
          try { if (!await recoverCart(sections)) location.reload(); } catch { /* Keep the original mutation error. */ }
          throw new Error(cart.description || cart.message || fallbackMessage);
        }
        if (!replaceSections(cart.sections, sections)) {
          let recovered = false;
          try { recovered = await recoverCart(sections); } catch { /* The mutation succeeded; do not roll back to an obsolete quantity. */ }
          if (!recovered) location.reload();
        } else publishCart(cart);
      });
    } catch (error) {
      const current = currentRow(context) || row;
      const currentPrimitive = current.querySelector('inventa-quantity');
      if (current === row) currentPrimitive?.reset(oldValue);
      currentPrimitive?.setError(error.message || retryMessage);
    } finally {
      pendingLines.delete(context.key);
      for (const scope of ['#cart-drawer', '[data-inventa-cart-page]']) busy(currentRow({...context, scope}), false);
      applyPending();
      restoreFocus(context, focus);
    }
  }

  document.addEventListener('inventa:quantity-change', event => {
    if (event.target.dataset.quantityAdapter !== 'cart') return;
    const row = event.target.closest('[data-inventa-line-key]');
    if (row) changeQuantity(row, event.detail.value);
  });

  document.addEventListener('click', event => {
    const remove = event.target.closest('[data-inventa-remove]');
    if (remove) {
      event.preventDefault();
      const row = remove.closest('[data-inventa-line-key]');
      if (row) changeQuantity(row, 0, true);
      return;
    }
    const quote = event.target.closest('[data-inventa-quote-cart]');
    if (quote) { event.preventDefault(); transferCartToQuote(quote); }
  });

  document.addEventListener('change', event => {
    if (event.target.matches('#inventa-cart-form [name="note"], #inventa-cart-form [name^="attributes["]')) saveDetails();
  });

  document.addEventListener('input', event => {
    if (event.target.matches('#inventa-cart-form [name="note"], #inventa-cart-form [name^="attributes["]')) detailEdits.set(event.target.name, event.target.value);
  });

  // Native Add/Refresh rendering also recreates controls while our queue may be pending.
  document.addEventListener('cart:change', applyPending);
  document.addEventListener('inventa:cart-rendered', applyPending);

  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!['inventa-cart-form', 'inventa-drawer-form'].includes(form.id) || event.submitter?.name !== 'checkout' || form.dataset.inventaCheckoutReady === 'true') return;
    if (quoteScope) { event.preventDefault(); return; }
    if (checkoutPending) { event.preventDefault(); return; }
    if (!queued && !detailEdits.size) return;
    event.preventDefault();
    checkoutPending = true;
    const submitter = event.submitter;
    submitter.setAttribute('aria-busy', 'true');
    applyPending();
    if (detailEdits.size) saveDetails();
    while (queued) await queue;
    const current = document.getElementById(form.id);
    const checkout = current?.querySelector('[name="checkout"]') || document.querySelector(`[form="${form.id}"][name="checkout"]`);
    if (current && checkout && !detailEdits.size) {
      current.dataset.inventaCheckoutReady = 'true';
      checkout.removeAttribute('aria-busy');
      current.requestSubmit(checkout);
      delete current.dataset.inventaCheckoutReady;
    } else submitter.removeAttribute('aria-busy');
    checkoutPending = false;
    document.querySelectorAll('[name="checkout"]').forEach(button => button.removeAttribute('aria-busy'));
    document.querySelectorAll('[data-inventa-quote-cart]').forEach(button => { button.disabled = false; });
  });

  function saveDetails() {
    const form = document.querySelector('#inventa-cart-form');
    if (!form) return;
    const attributes = {'Bestellnummer / interne Referenz': form.querySelector('[name="attributes[Bestellnummer / interne Referenz]"]')?.value || ''};
    const note = form.querySelector('[name="note"]')?.value || '';
    const values = new Map([['note', note], ['attributes[Bestellnummer / interne Referenz]', attributes['Bestellnummer / interne Referenz']]]);
    values.forEach((value, name) => detailEdits.set(name, value));
    const strings = messages();
    const status = text => { const node = document.querySelector('#inventa-cart-form .inventa-cart__field-status'); if (node) node.textContent = text; };
    status(strings.saving);
    enqueue(async () => {
      const response = await fetch(path('update'), {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes,note})});
      if (!response.ok) throw new Error(strings.details_error);
      values.forEach((value, name) => { if (detailEdits.get(name) === value) detailEdits.delete(name); });
      status(strings.saved);
    }).catch(error => { status(error.message || strings.details_error); });
  }

  function setQuoteBusy(selector, value) {
    const scope = document.querySelector(selector);
    const button = scope?.querySelector('[data-inventa-quote-cart]');
    if (!button) return;
    button.disabled = value;
    if (value) button.setAttribute('aria-busy', 'true'); else button.removeAttribute('aria-busy');
  }

  async function transferCartToQuote(button) {
    if (button.disabled || quoteScope || checkoutPending) return;
    const selector = surfaceSelector(button);
    const hadFocus = document.activeElement === button;
    const strings = messages();
    quoteScope = selector;
    const status = text => {
      const node = document.querySelector(selector)?.querySelector('.inventa-cart__quote-status, .inventa-cart-drawer__quote-status');
      if (node) { node.hidden = false; node.textContent = text; }
    };
    setQuoteBusy(selector, true);
    applyPending();
    status(strings.quote_loading);
    try {
      await enqueue(async () => {
        // The queue includes every already-started quantity/remove operation. Never
        // trust rendered JSON as the current cart, even when the drawer looks fresh.
        const response = await fetch(`${root}cart.js`, {credentials: 'same-origin', cache: 'no-store'});
        if (!response.ok) throw new Error(strings.cart_load_error);
        const cart = await response.json();
        const lines = cart.items;
        if (!Array.isArray(lines)) throw new Error(strings.cart_load_error);
        if (!lines.length) throw new Error(strings.empty_error);
        if (lines.some(line => line.selling_plan_allocation)) throw new Error(strings.subscriptions_error);
        if (lines.some(line => line.properties && Object.keys(line.properties).length)) throw new Error(strings.properties_error);
        const variants = lines.map(line => String(line.variant_id));
        if (new Set(variants).size !== variants.length) throw new Error(strings.duplicate_variant_error);
        const imported = [];
        for (const line of lines) {
          if (!line.handle) throw new Error(strings.product_link_error);
          const productResponse = await fetch(`${root}products/${encodeURIComponent(line.handle)}.js`, {credentials:'same-origin'});
          if (!productResponse.ok) throw new Error(strings.product_load_error);
          const product = await productResponse.json();
          if (!product.variants.some(variant => String(variant.id) === String(line.variant_id))) throw new Error(strings.variant_error);
          imported.push({product:{id:product.id,handle:product.handle,title:product.title,vendor:product.vendor,variants:product.variants.map(({id,title,sku,available,price})=>({id,title,sku,available,price}))},variantId:String(line.variant_id),quantity:String(line.quantity)});
        }
        // Read the draft at commit time, after product requests, to retain another
        // existing writer's latest selection and target prices where possible.
        let saved;
        try { saved = JSON.parse(localStorage.getItem('inventa-quote-selection-v1') || 'null'); } catch { saved = null; }
        if (!saved || !Array.isArray(saved.products) || Date.now() - saved.savedAt > 30 * 86400000) saved = {products: [], customProducts: []};
        const products = [...saved.products];
        for (const item of imported) {
          const previous = products.find(product => String(product.variantId) === item.variantId);
          item.targetPrice = previous?.targetPrice || '';
          if (previous) Object.assign(previous, item); else products.push(item);
        }
        if (products.length + (saved.customProducts?.length || 0) > 20) throw new Error(strings.quote_limit_error);
        saved.products = products;
        saved.savedAt = Date.now();
        localStorage.setItem('inventa-quote-selection-v1', JSON.stringify(saved));
        window.dispatchEvent(new Event('inventa:quote-change'));
        location.href = `${root}pages/angebotsanfrage`;
      });
    } catch (error) {
      status(error.message || strings.quote_error);
    } finally {
      quoteScope = null;
      setQuoteBusy(selector, false);
      transitionControls.forEach((wasDisabled, control) => { if (!wasDisabled) control.removeAttribute('disabled'); });
      transitionControls.clear();
      applyPending();
      if (hadFocus && document.activeElement === document.body) document.querySelector(selector)?.querySelector('[data-inventa-quote-cart]')?.focus({preventScroll: true});
    }
  }
})();

